/**
 * Public onboarding app — a self-contained React tree for the anonymous funnel.
 *
 * Mounted (instead of the authenticated panel) when the location is a public
 * onboarding route, so react-admin's `requireAuth` gate and the silent
 * single-sign-on boot never apply here. It carries only what these pages need:
 * the resolved brand theme and the translation provider.
 */

import React from 'react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { I18nContextProvider } from 'react-admin';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { i18nProvider } from '@/providers';
import { adminTheme as theme } from '@/themes';
import { appBase } from './publicRoutes';
import SignupPage from './SignupPage';
import PaymentConfirmingPage from './PaymentConfirmingPage';
import InviteLandingPage from './InviteLandingPage';

export const PublicApp: React.FC = () => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <I18nContextProvider value={i18nProvider}>
        <BrowserRouter basename={appBase() || undefined}>
          <Routes>
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/payment/confirming" element={<PaymentConfirmingPage />} />
            <Route path="/invite-user" element={<InviteLandingPage />} />
            <Route path="/invite-existing-user" element={<InviteLandingPage />} />
            <Route path="*" element={<Navigate to="/signup" replace />} />
          </Routes>
        </BrowserRouter>
      </I18nContextProvider>
    </ThemeProvider>
  </StyledEngineProvider>
);

export default PublicApp;
